import {Controller} from "stimulus"
import * as basicScroll from 'basicscroll'
import Browser from "../utils/Browser";

export default class extends Controller {

    static targets = []

    initialize() {

        const browser = new Browser

        if ( browser.name === "Internet Explorer" ) {
            return false
        }

        this.initScene()

    }

    initScene() {

        const instance = basicScroll.create({
            elem: this.element,

            // First argument = from where the animation start
            // Second argument = linked to the element
            // from: "top-bottom",

            // Second argument = where the animation end
            // top: "bottom-top",

            from: 'middle-bottom',
            to: 'bottom-top',
            //to: "top-top",
            direct: true,
            props: {
                '--translateY': {
                    from: `${ 0 }px`,
                    to: `${ 1 * (this.value * this.modifier) }px`
                }
            }
        })

        instance.start()


    }

    get modifier(){
        const value = parseFloat(this.data.get("modifier"))
        return isNaN(value) ? 1 : value
    }

    get value(){
        const value = parseFloat(this.data.get("value"))
        return isNaN(value) ? 10 : value
    }

}